import { CircleNotch } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

export function Loader({ fullscreen = false, className, label = 'A carregar…' }) {
  if (fullscreen) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center bg-background">
        <CircleNotch
          aria-label={label}
          className="h-8 w-8 animate-spin text-sage-600"
        />
      </div>
    );
  }
  return (
    <CircleNotch
      aria-label={label}
      className={cn('h-5 w-5 animate-spin text-sage-600', className)}
    />
  );
}
